<template>
  <section class="login-header cabinet-login-header">
    <div class="login-header__logo">
      <img v-if="region === 'uk'" src="/assets/images/tradeview-uk.png" class="collapsed-logo" />
      <img v-else-if="region === 'forex'" src="/assets/images/logo_tradeview_white.svg" class="collapsed-logo" />
      <img v-else-if="region === 'latam'" src="/assets/images/logo_tradeview_white.svg" class="collapsed-logo" />
      <img v-else-if="region ==='mena'" src="/assets/images/logo_tradeview-red-white.svg" alt="">
      <img v-else src="/assets/images/logo_tradeview-red-white.svg" alt="">
      
    </div>
<!--    <div class="login-header__options">-->
<!--      &lt;!&ndash;      <button @click="contactUsClicked">Contact us</button>&ndash;&gt;-->
<!--      <div class="login-header__pipe">|</div>-->
<!--      <CustomSelector class="login-header__language" v-model="language" :options="languages"></CustomSelector>-->
<!--    </div>-->
  </section>
</template>
<script>

import { ref } from "@vue/runtime-core";
export default {
  name: "Header",
  setup() {
    const region = ref(process.env.VUE_APP_CABINET_ORIGIN)
    return {
      region
    }
  }
}
</script>